import commonEN from '../locales/en/common.json';
import navigationEN from '../locales/en/pages.navigation.json';
import dashboardEN from '../locales/en/pages.dashboard.json';

import commonMS from '../locales/ms/common.json';
import navigationMS from '../locales/ms/pages.navigation.json';
import dashboardMS from '../locales/ms/pages.dashboard.json';

export const i18nResources = {
  en: {
    // Namespaces
    common: commonEN,
    navigation: navigationEN,
    dashboard: dashboardEN,
  },
  ms: {
    // Namespaces
    common: commonMS,
    navigation: navigationMS,
    dashboard: dashboardMS,
  },
};